import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaWhatsapp } from "react-icons/fa";
import chicaImg from "../../assets/img/ChatBot.png";

const Contacto = () => {
  return (
    <Container>
      <Row id="tengo-un-siniestro">
        <Col md={8} xs={12} className="mx-auto">
          <section className="contacto-section">
            <div className="contacto-container">
              <img src={chicaImg} alt="Chica atención" className="contacto-chica" />
              <div className="contacto-content ps-md-5 pe-md-5">
                <h2 className="contacto-title">Tengo un siniestro</h2>
                <p className="contacto-sub">¡Estamos para ayudarte!</p>
                <p className="contacto-desc">
                  Escríbenos al WA de servicio al cliente o bien, llámanos al número{" "}
                  <span className="contacto-tel">55 5203 0377</span>
                </p>
                <Button
                  className="contacto-btn"
                  href="https://api.whatsapp.com/send?phone=5215552030377&text=Hola%2C%20escribo%20desde%20el%20Portal%20Web%20para%20solicitar%20apoyo%20por%20Siniestro.%20%E2%9A%A0%EF%B8%8F"
                  target="_blank"
                >
                  <FaWhatsapp /> Quiero comunicarme
                </Button>
              </div>
            </div>
          </section>
        </Col>
      </Row>
    </Container>
  );
};

export default Contacto;
